import { loadRemoteModule } from '@angular-architects/module-federation';
import {
  Component,
  ComponentFactoryResolver,
  Inject,
  Injector,
  Input,
  OnInit,
  Optional,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { BasicPlan, ContributionRequest } from 'src/app/model/contribution.model';
import { SupportedContributionType } from 'src/app/model/contribution.type';
import { DataService } from 'src/app/shared/services/data.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-ps-contribution',
  templateUrl: './ps-contribution.component.html',
  styleUrls: ['./ps-contribution.component.scss']
})
export class PsContributionComponent implements OnInit {
  @ViewChild('dynamicComponent', { read: ViewContainerRef, static: true })
  viewContainer!: ViewContainerRef;
  contributionComponent: any;
  contributionData = new ContributionRequest();
  supportedContributions: string[] = [];
  
  selectedCensusDetails: any;
  public packagePlans: any[] = [];
  constructor(
    public dialog: MatDialogRef<PsContributionComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private injector: Injector,
    private resolver: ComponentFactoryResolver,
    public dataService: DataService,
  ) {}
  ngOnInit(): void {
    this.packagePlans =  this.data.rateTableInfo.PlanSelection.flatMap(z=>z.Networks.flatMap(x=>x.Plans));
    this.initContributionModule();
    this.mapContributionRequest();

    this.supportedContributions.push(
      SupportedContributionType[SupportedContributionType.none],
    );
    this.supportedContributions.push(
      SupportedContributionType[SupportedContributionType.percent],
    );
    this.supportedContributions.push(
      SupportedContributionType[SupportedContributionType.dollar],
    );
  }
  mapContributionRequest(): void {
    let employerContribution =  this.data.rateTableInfo.EmployeeContribution;
    this.contributionData.Id = 1;
    this.contributionData.BundleId =  this.data.rateTableInfo.PlanSelection[0].PackageId;
    this.contributionData.ApplyToAllPackages = false;
    this.contributionData.DifferentContributionPerCarrier = false;
    this.contributionData.ContributionAmountTypeId =
      employerContribution.ContributionAmountTypeId; //1, 2, 3, 4, //None, Percent, FlatAmount, EEPaysFlatAmount
    this.contributionData.SelectedContributionAmountType = employerContribution.EmployerContributionTypeId; //None, Percent, FlatAmount, EEPaysFlatAmount
    this.contributionData.Title =  this.data.rateTableInfo.Carrier.CarrierName;
    this.contributionData.IsWrap = false;
    this.contributionData.IsAcknowledged = false;
    this.contributionData.HasDependents =true;
    this.contributionData.RequirePayPeriod=true;
    this.contributionData.PayPeriodTypeId=employerContribution.PayPeriod;
    this.contributionData.ParentApp = 'RT'; //ParentType;
    this.contributionData.TotalPremium=10000; //there will be another story to fix Total Premium
    this.contributionData.SupportedContributionTypes =
      this.supportedContributions && this.supportedContributions.length
        ? [...new Set(this.supportedContributions)]
        : undefined;
    let carrier = {
      CarrierName:  this.data.rateTableInfo.Carrier.CarrierName,
      CarrierId :  this.data.rateTableInfo.Carrier.nqsCarrierId,
      Thresholds: null,
      PlanList: [],
      OOSEmployeeList: [],
    };
    let planList=[];
    this.data.rateTableInfo.PlanSelection
    .map((n) =>
     n.Networks.forEach((p)=>
     p.Plans.forEach((plan)=>
     {
      const basicPlan = new BasicPlan();
      basicPlan.BundleId = n.PackageId;
      basicPlan.NQSPlanId = plan.PlanId;
      basicPlan.BundlePlanId = plan.PlanId;
      basicPlan.MediumName = plan.PlanName ? plan.PlanName : '';
      basicPlan.Network = p.NetworkName ? p.NetworkName : '';
      basicPlan.BenefitType = '';
      basicPlan.MetalTierType = plan.MetalTier ?? 'None';
      basicPlan.TotalPremium = 100;
      planList.push(basicPlan);
     })));
     carrier.PlanList=planList;
    this.contributionData.Carriers = [carrier];
    this.contributionData.ContributionItems = [];
    this.contributionData.ContributionItems.push({
      CarrierId: carrier.CarrierId,
      BundleId: 1,
      CarrierName: carrier.CarrierName,
      ContributionAmountTypeId:
      employerContribution?.ContributionAmountTypeId,
      ContributionBasisType:
      employerContribution?.EmployerContributionTypeId,
      EmployeeContributionPercent:
        +employerContribution?.EmployeeContributionPercent,
      EmployeeContributionAmount:
        +employerContribution?.EmployeeContributionAmount,
      DependentContributionPercent:
        +employerContribution
          ?.DependentContributionPercent,
      DependentContributionAmount:
        +employerContribution?.DependentContributionAmount,
      IsRollExcess: employerContribution?.IsRollExcess,
      EmployerSelectedPlanId: employerContribution?.EmployerSelectedPlanId,
      EmployerSelectedPlanName: employerContribution?.EmployerSelectedPlan,
      IsEEPaysAllDependentAmount:
      employerContribution?.IsEEPaysAllDependentAmount,
      SelectedFlatContributionAmountType: '', // static
      SelectedEmployerContributionType: '', // static
      OOSEmployeeList: [],
      IsAcknowledged: false, // static
      showOOS: false, // static
    });

    this.contributionData.IsContributionItem = false;
    this.contributionData.OOSEmployeesExist = false;
    this.contributionData.EnableApplyToAllPackages =
      false;
  }
  private initContributionModule() {
    loadRemoteModule({
      remoteEntry:
        environment.apiEndPoints.contributionHost +
        environment.apiEndPoints.contributionEndPoint,
      remoteName: 'contribution',
      exposedModule: './DynamicContribution',
    })
      .then((m) => {
        return m.ContributionComponent;
      })
      .catch((e) => {
        console.log('An error occurred, please try again later.');
      })
      .then((comp) => {
        const factory = this.resolver.resolveComponentFactory(comp);
        const contributionComponent: any = this.viewContainer.createComponent(
          factory,
          undefined,
          this.injector,
        );
        this.contributionComponent = contributionComponent;
        contributionComponent.instance.getContributionData(
          JSON.stringify(this.contributionData),
          true,
        );
        contributionComponent.instance.cancelEvent.subscribe({
          next: (event: any) => {
            this.dialog.close();
          },
        });

        contributionComponent.instance.confirmEvent.subscribe({
          next: (event: any) => {
            if (event) {
              let contributionDetail=event.ContributionItems[0];
              let planName=
              this.contributionData.Carriers[0].PlanList.filter(z=>z.NQSPlanId==contributionDetail?.EmployerSelectedPlanId);
              this.data.rateTableInfo.EmployeeContribution.ContributionAmountTypeId=contributionDetail?.ContributionAmountTypeId;
              this.data.rateTableInfo.EmployeeContribution.EmployerContributionTypeId=contributionDetail?.ContributionBasisType;
              this.data.rateTableInfo.EmployeeContribution.DependentContributionPercent=contributionDetail?.DependentContributionPercent ??0;
              this.data.rateTableInfo.EmployeeContribution.EmployeeContributionPercent=contributionDetail?.EmployeeContributionPercent??0;
              this.data.rateTableInfo.EmployeeContribution.DependentContributionAmount=contributionDetail?.DependentContributionAmount ?? 0;
              this.data.rateTableInfo.EmployeeContribution.EmployeeContributionAmount=contributionDetail?.EmployeeContributionAmount ?? 0;
              this.data.rateTableInfo.EmployeeContribution.EmployerSelectedPlan=planName.length>0?planName[0].MediumName : "";
              this.data.rateTableInfo.EmployeeContribution.PayPeriod=event?.PayPeriodTypeId;
              this.data.rateTableInfo.EmployeeContribution.EmployerSelectedPlanId =contributionDetail?.EmployerSelectedPlanId??0;
              this.data.rateTableInfo.EmployeeContribution.IsEEPaysAllDependentAmount=contributionDetail?.IsEEPaysAllDependentAmount
              this.dialog.close(this.data);
            }
          },
        });
      });
  }
  async saveContrbutionEvent(showNotification: boolean): Promise<boolean> {
    const contributionResponse =
      this.contributionComponent.instance.ConfirmClick();
    if (contributionResponse == null) {
      return false;
    }
    return true;
  }
}
